import React from "react";
import OmSymbol from "./OmSymbol";

export default function EmptyState({ title = "Nothing here yet", subtitle = "" }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <span className="text-5xl mb-4 flex justify-center text-saffron-400"><OmSymbol size={48} /></span>
      <p className="font-heading text-xl text-maroon-800 mb-1">{title}</p>
      {subtitle && <p className="text-gray-500 text-sm max-w-sm">{subtitle}</p>}
    </div>
  );
}
